import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Section = styled.section`
  background: var(--gradient-surface);
  padding: 120px 0;
  margin-top: 0;
  position: relative;
  overflow: hidden;

  &::before, &::after {
    content: '';
    position: absolute;
    width: 1200px;
    height: 1200px;
    border-radius: 50%;
    background: var(--gradient-primary);
    opacity: 0.05;
  }

  &::before {
    top: -600px;
    right: -300px;
    animation: float 8s ease-in-out infinite;
  }

  &::after {
    bottom: -600px;
    left: -300px;
    animation: float 8s ease-in-out infinite reverse;
  }

  @keyframes float {
    0%, 100% { transform: translateY(0) rotate(0deg); }
    50% { transform: translateY(-30px) rotate(5deg); }
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 40px;
  }
`;

const Content = styled.div`
  max-width: 600px;
  animation: slideIn var(--transition-normal) forwards;

  h2 {
    font-size: 48px;
    font-weight: 800;
    background: var(--gradient-primary);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 24px;
    line-height: 1.2;
  }

  p {
    font-size: 20px;
    color: var(--text-secondary);
    margin: 0;
    line-height: 1.6;
  }
`;

const CTAButton = styled(Link)`
  background: var(--gradient-primary);
  color: white;
  padding: 16px 40px;
  border-radius: 100px;
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
  transition: all var(--transition-normal);
  box-shadow: var(--shadow-md);
  position: relative;
  overflow: hidden;
  animation: fadeIn var(--transition-normal) forwards;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      to right,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transform: translateX(-100%);
    transition: transform 0.6s ease;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: var(--shadow-primary);

    &::before {
      transform: translateX(100%);
    }
  }

  &:active {
    transform: translateY(-1px);
  }
`;

const Highlight = styled.span`
  color: var(--primary);
  font-weight: 700;
`;

const CTASection = () => {
  return (
    <Section>
      <Container>
        <Content>
          <h2>Take Control of Your Subscriptions Today</h2>
          <p>
            Join thousands of users who save <Highlight>$240+</Highlight> yearly by managing their subscriptions with Nexpend.
          </p>
        </Content>
        <CTAButton to="/signup">
          Get Started — It's Free
        </CTAButton>
      </Container>
    </Section>
  );
};

export default CTASection; 